import React from 'react'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import Async from '../../../../modules/asyncCache/components/Async'
import {diocese_getById_Api, parish_getById_Api, religiousOrder_getById_Api, yellowPage_getById_Api,} from 'apis'
import {DetailViewForm as DioceseDetailViewForm} from '../../Diocese/components/DioceseForm'
import {DetailViewForm as ReligiousOrderDetailViewForm} from '../../ReligiousOrder/components/ReligiousOrderForm'
import {DetailViewForm as ParishDetailViewForm} from '../../Parish/components/ParishForm'
import {YellowPageDetailViewForm} from '../../YellowPage/components/YellowPageForm'
import {DetailForm as ProfileDetailForm} from '../../Profile/components/ProfileForm'
import ProfileContext, {ProfileProvider} from '../../Profile/ProfileContext'
import {DirectoryTypeKeys} from '../consts/directoryTypes'
import {DrawDialog} from '../../../../components/drawer/dialog/DrawDialog'

// Trigger ẩn — DrawDialog vốn thiết kế để tự chứa nút mở (component), nhưng ở đây
// open/close do DiscoveryPage.js (selectedDetail state) điều khiển từ ngoài, nên
// dùng span ẩn làm trigger no-op, đóng/mở qua prop visible + onCancel.
const hiddenTrigger = <span style={{display: 'none'}}/>

// Dispatch theo type, dùng lại đúng form/modal đã có ở từng trang danh sách gốc
// (Dioceses.js, ReligiousOrders.js, Parishes.js, YellowPages.js, ProfileSearchView.js) —
// sửa 1 chỗ ở các form gốc đó thì Danh Bạ tự động ăn theo, không có bản sao riêng.
const CASES = {
    [DirectoryTypeKeys.PARISH]: {
        title: 'parish information',
        width: 640,
        apiInfo: parish_getById_Api,
        DetailComponent: ParishDetailViewForm,
    },
    [DirectoryTypeKeys.DIOCESE]: {
        title: 'diocese information',
        width: 640,
        apiInfo: diocese_getById_Api,
        DetailComponent: DioceseDetailViewForm,
    },
    [DirectoryTypeKeys.RELIGIOUS_ORDER]: {
        title: 'religious order information',
        width: 640,
        apiInfo: religiousOrder_getById_Api,
        DetailComponent: ReligiousOrderDetailViewForm,
    },
    // [DirectoryTypeKeys.ORGANIZATION]: {
    //     title: 'organization information',
    //     width: 640,
    //     apiInfo: organization_getById_Api,
    //     DetailComponent: ReligiousOrderDetailViewForm,
    // },
    // Hội đoàn nguồn dữ liệu là Organization (org_type=999) — luôn có route /organization/:id
    // thật, nên openDetail() điều hướng thẳng thay vì mở modal ở đây (xem DiscoveryPage.js).
    [DirectoryTypeKeys.YELLOW_PAGE]: {
        title: 'name card information',
        width: 540,
        apiInfo: yellowPage_getById_Api,
        DetailComponent: YellowPageDetailViewForm,
    },
}

const DirectoryDetailModal = ({item, typeKey, onClose}) => {
    const t = useTranslate()

    if (!item) return null

    if (typeKey === DirectoryTypeKeys.PROFILE) {
        return (
            <DrawDialog
                width={600}
                visible={true}
                footer={false}
                component={hiddenTrigger}
                onCancel={onClose}
                title={
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('personal profile')}
                    </div>
                }>
                {(isToggle) => isToggle && (
                    <ProfileProvider item={item}>
                        <ProfileContext.Consumer>
                            {({item: fullItem}) => <ProfileDetailForm item={fullItem} onCancel={onClose}/>}
                        </ProfileContext.Consumer>
                    </ProfileProvider>
                )}
            </DrawDialog>
        )
    }

    const config = CASES[typeKey]
    if (!config) return null

    const {title, width, apiInfo, DetailComponent} = config

    return (
        <DrawDialog
            width={width}
            visible={true}
            footer={false}
            component={hiddenTrigger}
            onCancel={onClose}
            title={
                <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                    {t(title)}
                </div>
            }>
            {(isToggle) => isToggle && (
                <Async apiInfo={apiInfo} query={{':id': item?.id}}>
                    {(data) => {
                        const dataItem = _.get(data, 'response.data', item)
                        return <DetailComponent item={dataItem} onCancel={onClose}/>
                    }}
                </Async>
            )}
        </DrawDialog>
    )
}

export default DirectoryDetailModal
